import {
  ChatContainer,
  ChatContainerAlignment,
} from "@risalabs_frontend_org/oasis-ui-kit";
import { useMemo } from "react";

interface TaskHistoryTabProps {
  taskHistory?: string;
}

interface TaskHistoryEntry {
  sender: string;
  text: string;
}

interface ChatMessage {
  message: string;
  senderName: string;
  alignment: ChatContainerAlignment;
}

const RISA_SENDERS = new Set(["RISA", "SYSTEM"]);

const parseTaskHistory = (raw?: string): ChatMessage[] => {
  if (!raw) return [];
  try {
    const parsed: TaskHistoryEntry[] = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((entry) => entry.text)
      .map((entry) => {
        const isRisa = RISA_SENDERS.has(entry.sender);
        return {
          message: entry.text,
          senderName: isRisa
            ? "RISA"
            : entry.sender === "OTHER"
              ? "Astera"
              : entry.sender || "Client",
          alignment: (isRisa ? "right" : "left") as ChatContainerAlignment,
        };
      });
  } catch {
    return [];
  }
};

const TaskHistoryTab = ({ taskHistory }: TaskHistoryTabProps) => {
  const messages = useMemo(() => parseTaskHistory(taskHistory), [taskHistory]);

  if (messages.length === 0) {
    return (
      <div className="flex h-full w-full items-center justify-center p-3 text-sm text-gray-400">
        No task history available.
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-y-auto p-3">
      {messages.map((chat, index) => (
        <ChatContainer
          key={index}
          senderName={chat.senderName}
          timestamp=""
          message={chat.message}
          alignment={chat.alignment}
          maxWidth="100%"
        />
      ))}
    </div>
  );
};

export default TaskHistoryTab;
